<template>
  <div class="h3">
    Enfin :
  </div>

  <ul>
    <li>Vous acceptez le courrier électronique comme moyen de correspondance.</li>
    <li>Vous n'avez pas été résilié(e) pour non paiement de prime par un précédent assureur.</li>
    <li>
      Vous reconnaissez avoir été informé(e) que :
      <ul>
        <li>
          L'assureur se fonde, pour établir les relations précontractuelles, sur le Code des assurances et notamment son article L112-2.
          La loi applicable au présent contrat, régi par le Code des assurances, est la loi française.<br>
          L'assureur, avec votre accord, s'engage à utiliser pendant toute la durée du contrat la langue française.
        </li>
        <li>
          Le contrat ou l'adhésion est conclu pour une durée annuelle. A l'expiration de chaque période annuelle, il est reconduit de plein droit d'année en année, sauf renonciation par vous ou l'assureur dans les conditions prévues par la loi, rappelées aux dispositions générales du contrat.
        </li>
      </ul>
    </li>
  </ul>

  <p><span class="strong">Ce contrat étant souscrit dans le cadre d'un système de commercialisation à distance</span> (article L112-2 du code des assurances et L121-20-8 du code de la consommation),</p>
  <ul>
    <li>
      Vous demandez expressément l'exécution immédiate et intégrale du contrat à compter de sa conclusion.
    </li>
    <li>
      Dans ce cadre et conformément aux textes précités, vous disposez d'un délai de 14 jours calendaires révolus, à compter de la conclusion du contrat (envoi des documents contractuels par l'assureur), pour vous rétracter.
      Cette renonciation doit être faite par lettre recommandée avec accusé de réception, envoyée à la Direction Services Clients de SwissLife Prévoyance et Santé - 60 boulevard de la Liberté - 59717 Lille Cedex 9.
      Elle peut être faire suivant le modèle de lettre inclus dans les dispositions générales valant notice d'information.
    </li>
    <li>
      La cotisation, dont vous êtes redevable en contrepartie de l'exécution immédiate et intégrale du contrat avant expiration de ce délai de rétractation, est égale au prorata de la cotisation annuelle pour la période écoulée entre la conclusion du contrat et votre éventuelle rétractation.
    </li>
    <li>
      En cas de rétractation :
    </li>
    <ul>
      <li>
        si des prestations ont été versées, vous vous engagez à rembourser à l'assureur les montants perçus dans un délai de 30 jours,<br>
      </li>
      <li>
        si des cotisations ont été perçues, l'assureur les remboursera déductions faites de la cotisation au prorata de la période de garantie dans un délai de 30 jours.
      </li>
    </ul>
  </ul>
  <p><span class="strong">Vous autorisez Swiss Life à envoyer des instructions à votre banque pour débiter votre compte et vous autorisez votre banque à débiter votre compte conformément aux instructions de Swiss Life.</span></p>

  <p>
    En cas de litige sur un prélèvement, vous pourrez en faire suspendre l'exécution par simple demande à l'établissement teneur de votre compte.
    Vous réglerez le différend directement avec le créancier. Les informations contenues dans la présente autorisation ne seront utilisées que pour les seules nécessités de la gestion et pourront donner lieu à l'exercice du droit individuel d'accès et de rectification auprès du créancier à l'adresse suivante: SwissLife Prévoyance et Santé - 1 rue du Maréchal de Lattre de Tassigny - 59671 ROUBAIX CEDEX 1
  </p>

  <p><span class="strong">Vous avez lu, compris, et vous acceptez les Dispositions Générales</span> qui sont annexées à la présente proposition.</p>

  <p class="soulignement strong">
    Votre souscription est sur le point d'être finalisée, veuillez confirmer votre souscription en ligne pour l'entériner.
  </p>
  <p>Nous restons à votre disposition pour de plus amples renseignements.</p>

  <p>
    Bien cordialement<br><br>
    <span style="margin-left:50px;">Votre conseiller SwissLife</span>
  </p>
  <p>
    Votre cotisation hors taxes comporte 25,70% de frais*.<br>
    Le pourcentage des versements effectués par Swiss Life au titre de ses contrats de complémentaire santé responsables s'élève à 71,20%**.<br>
    <br>
    * Le ratio entre le montant total des frais de gestion au titre du remboursement et de l’indemnisation des frais occasionnés par une maladie, une maternité ou un accident et le montant des cotisations ou primes afférentes à ces garanties représente la part des cotisations ou primes collectées, hors taxes, par l’organisme assureur au titre de l’ensemble des garanties couvrant le remboursement ou l’indemnisation des frais précités, qui est utilisée pour le financement des frais de gestion.<br>
    Ces frais de gestion recouvrent l’ensemble des sommes engagées pour concevoir les contrats, les commercialiser (dont le réseau commercial, le marketing, les commissions des intermédiaires), les souscrire (dont l’encaissement des cotisations, la gestion des résiliations, le suivi comptable et juridique) et les gérer (dont le remboursement, la gestion du tiers payant, l’information client, l’assistance, les services, les prestations complémentaires), c’est-à-dire accomplir toutes les tâches incombant à l’organisme assureur dans le respect des garanties contractuelles. L'année de référence retenue pour le calcul de ces frais est l'année 2019.<br>
    ** Le ratio entre le montant des prestations versées pour le remboursement et l’indemnisation des frais occasionnés par une maladie, une maternité ou un accident et le montant des cotisations ou primes afférentes à ces garanties représente la part des cotisations ou primes collectées, hors taxes, par l’organisme assureur au titre de l’ensemble des garanties couvrant le remboursement ou l’indemnisation des frais précités, qui est utilisée pour le versement des prestations correspondant à ces garanties. L'année de référence retenue pour le calcul de ce ratio est l'année 2019.<br>
  </p>
  <p>
    <span class="strong">Mentions légales</span><br>
    SwissLife Prévoyance et Santé - Siège social : 7 rue Belgrand 92682 Levallois-Perret Cedex<br>
    SA au capital social de 150 000 000 euros - Entreprise régie par le code des assurances - 322 215 021 RCS Nanterre
  </p>
</template>

<script>
export default {
  name: "RecapitulatifFinal"
}
</script>

<style scoped>

</style>
